/* #region header */
/**************************************************************************************************
//
//  Description: Ambulance Location Categories
//
//  Copyright:    © 2021 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   13.04.21 Sean Flook         WI39345 Initial Revision.
//    002   12.05.21 Sean Flook         WI39345 Added avatar_icon property.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
/* #endregion header */

const LocationCategoryAmbulance = [
  {
    id: 1,
    category: "Access Marker",
    avatar_id: 1,
    avatar_text: "AM",
    avatar_icon: "/images/categories/AccessMarker.svg",
  },
  {
    id: 2,
    category: "Helipad Notes",
    avatar_id: 2,
    avatar_text: "HN",
    avatar_icon: "/images/categories/HelipadNotes.svg",
  },
  {
    id: 3,
    category: "Route Marker",
    avatar_id: 3,
    avatar_text: "RM",
    avatar_icon: "/images/categories/RouteMarker.svg",
  },
  {
    id: 4,
    category: "COMAH Site",
    avatar_id: 4,
    avatar_text: "CS",
    avatar_icon: "/images/categories/COMAHSite.svg",
  },
];

export default LocationCategoryAmbulance;
